<template>
  <div class="bar_top d-flex justify-content-between">
    <div class="">
      <h2
        v-show="title"
        class="title"
        :style="{ fontSize: font ? font + 'px' : '32px' }"
      >
        {{ title }}
      </h2>
    </div>
    <div
      v-show="input"
      class="left-area d-flex justify-content-md-end flex-row"
    >
      <div class="search-input ">
        <input
          v-debounce:500ms="serach"
          type="text"
          :placeholder="placeholder"
          class="form-control"
          v-model="serachTocken"
        />
      </div>
      <div class="slot"><slot></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BarTop",
  props: ["title", "input", "placeholder", "font"],
  data() {
    return {
      serachTocken: null,
    };
  },
  methods: {
    btnClicked() {
      this.$emit("button-clicked");
    },
    serach() {
      this.$emit("get-search", this.serachTocken);
    },
  },
};
</script>

<style lang="scss" scoped>
.bar_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333;
  // .title {
  //   font-weight: 300;
  // }
  .left-area{
    width: 40vw !important;
  }
  .search-input {
    position: relative;
    // margin-bottom: 5px;
    width: 380px;
    input {
      border: 1px solid #eaeaea;
      background-color: #ffffff;
      border-radius: 0.4rem;
      width: 100%;
      height: 39px;
      font-size: 15px;
      padding-left: 10px;
      :focus {
        outline: none !important;
      }
    }
    ::placeholder {
      color: #666;
    }
    &:after {
      position: absolute;
      font-family: "Font Awesome 5 Free";
      content: url(../../assets/Icons/svg/search.svg);
      font-weight: 900;
      right: 13px;
      top: 10px;
      color: #7794cc;
    }
  }
  @media (max-width: 765px) {
    flex-direction: column;
    .title {
      width: 100vw;
      font-size: 20px !important;
      text-align: center;
    }
    .left-area{
     width: 100% !important;
      .search-input { width:  100%}
    }
    .slot {
      display: none;
    }
  }
}
</style>
